<template>
    <app-label
        :show-label="showLabel === true || (showLabel === 'onFocus' && hasFocus)"
        :label="label"
        :class="{ 'cursor-pointer': !disabled, 'flex-col': showLabel === 'onFocus' }"
        class="flex gap-1"
    >
        <slot v-if="!hasFocus">
            <div :class="{ underline: !disabled }" class="flex">
                <span v-if="internalValue || internalValue === 0">{{ internalValue }}</span>
                <span v-else>...</span>
            </div>
        </slot>
        <input
            :style="{ opacity }"
            :class="{ absolute: !opacity }"
            :disabled.prop="disabled"
            class="bg-inherit w-full"
            style="left: -10000px"
            type="number"
            size="3"
            v-model="internalValue"
            @focus="onFocus"
            @blur="onBlur"
            @keyup.enter="validate"
            @keyup.esc="discard"
            @keydown.space.prevent
            @keydown.enter.prevent
            ref="input"
        />
    </app-label>
</template>
<script>
import AppLabel from '@/components/appLabel/AppLabel';
export default {
    components: { AppLabel },
    watch: {
        value(value) {
            this.internalValue = value;
        },
    },
    created() {
        this.internalValue = this.value;
    },
    data() {
        return {
            opacity: 0,
            hasFocus: false,
            preventBlur: false,
            internalValue: null,
        };
    },
    methods: {
        focus() {
            this.$refs.input.focus();
        },
        discard() {
            this.preventBlur = true;
            this.reset();
        },
        validate(event) {
            event.preventDefault();
            this.preventBlur = true;
            this.reset();
            this.save(this.$refs.input.value);
            this.$emit('enter');
        },
        reset() {
            this.opacity = 0;
            this.internalValue = this.value;
            this.$refs.input.blur();
        },
        save(value) {
            if (value) {
                let regex;

                if (this.format === 'integer') {
                    if (this.positiveOnly) {
                        regex = /[^0-9]/g;
                    } else {
                        regex = /[^\-0-9]/g;
                    }
                    const numericChars = value.replace(regex, '');
                    if (numericChars.length > 0) {
                        this.$emit('input', parseInt(numericChars));
                    }
                } else {
                    if (this.positiveOnly) {
                        regex = /[^0-9,.]/g;
                    } else {
                        regex = /[^\-0-9,.]/g;
                    }
                    const numericChars = value
                        //normalize decimal separator to ,
                        .replace(/,/g, '.')
                        // remove forbidden chars
                        .replace(regex, '');
                    if (numericChars.length > 0) {
                        this.$emit('input', parseFloat(numericChars));
                    }
                }
            } else {
                this.$emit('input', null);
            }
        },
        onFocus() {
            this.hasFocus = true;
            this.opacity = 1;
            this.preventBlur = false;
            this.$nextTick(() => {
                this.$refs.input.select();
            });
        },
        onBlur($event) {
            this.hasFocus = false;
            if (!this.preventBlur) {
                this.reset();
                this.save($event.target.value);
            }
        },
    },
    props: {
        label: String,
        positiveOnly: { type: Boolean, default: true },
        disabled: { type: Boolean, default: false },
        value: Number,
        showLabel: { type: String | Boolean, default: true },
        format: { type: String, default: 'integer' },
    },
};
</script>
